var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help-center__banner"},[_c('div',[_c('strong',[_vm._v(" Ainda precisa de ajuda? ")])]),_vm._v(" "),_c('div',[_c('span',[_vm._v("\n      Podemos te atender melhor pelo "),_c('br'),_vm._v("\n      telefone 0800-643-8100 Opção 3.\n    ")])])])
}]
render._withStripped = true
export { render, staticRenderFns }